import { updateUsergroupActions } from '../../constants';

export const editUserGroup = (category, code) => ({
  type: updateUsergroupActions.EDIT_USERGROUP,
  category,
  code,
});

export const editUserGroupCancel = (category, code) => ({
  type: updateUsergroupActions.EDIT_USERGROUP_CANCEL,
  category,
  code,
});

export const updateUserGroupError = (category, code, error) => ({
  type: updateUsergroupActions.UPDATE_USERGROUP_ERROR,
  category,
  code,
  error,
});

export const updateUserGroupProperties = (category, code, properties) => ({
  type: updateUsergroupActions.UPDATE_USERGROUP_PROPERTIES,
  category,
  code,
  properties,
});

export const updateUserGroupSuccess = (category, code, result) => ({
  type: updateUsergroupActions.UPDATE_USERGROUP_SUCCESS,
  category,
  code,
  result,
});

export const updateUserGroup = (category, code) => ({
  type: updateUsergroupActions.UPDATE_USERGROUP,
  category,
  code,
});

export const updateActiveUserGroupProperties = (properties) => ({
  type: updateUsergroupActions.UPDATE_ACTIVE_USERGROUP_PROPERTIES,
  properties,
});
